var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14258 12.6484H13.2845",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.213 1.38788C10.4845 1.11639 10.8527 0.963867 11.2367 0.963867C11.4268 0.963867 11.615 1.00131 11.7907 1.07407C11.9663 1.14682 12.1259 1.25345 12.2603 1.38788C12.3948 1.52231 12.5014 1.6819 12.5742 1.85755C12.6469 2.03319 12.6844 2.22144 12.6844 2.41155C12.6844 2.60166 12.6469 2.78991 12.5742 2.96556C12.5014 3.1412 12.3948 3.30079 12.2603 3.43522L3.72978 11.9658L1 12.6482L1.68244 9.91844L10.213 1.38788Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.e713869f1a06a0c4574f309a59822df8.svg";
export { ForwardRef as ReactComponent };